import { DashStyleValue } from "highcharts";
import { NormalizedWidgetAggregatedCost } from "@/services/cloudchipr.api";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";

export const generateHighChartsDataForNormalizedCostWidget = (
  regular?: NormalizedWidgetAggregatedCost[],
  normalized?: NormalizedWidgetAggregatedCost[],
): HighchartsChartDataType => {
  const categories = regular?.map((group) => group.value) ?? [];

  const costData = [
    {
      name: "Actual Cost",
      color: normalizedCostWidgetActualCostColor,
      data: regular?.map((value) => ({ y: value.cost })) ?? [],

      marker: {
        enabled: true,
        fillColor: "transparent",
        lineColor: normalizedCostWidgetActualCostColor,
        lineWidth: 2,
        radius: 4,
        symbol: "circle",
        states: {
          hover: {
            enabled: true,
            fillColor: normalizedCostWidgetActualCostColor,
            radius: 4,
          },
        },
      },
    },
    {
      name: "Normalized Cost",
      color: normalizedCostWidgetNormalizedColor,
      data: normalized?.map((value) => ({ y: value.cost })) ?? [],
      dashStyle: "Dash" as DashStyleValue,
      lineColor: normalizedCostWidgetNormalizedLineColor,
      lineWidth: 2,
      borderColor: normalizedCostWidgetNormalizedBorderColor,
      borderWidth: 1,

      marker: {
        enabled: true,
        fillColor: "transparent",
        lineColor: normalizedCostWidgetNormalizedBorderColor,
        lineWidth: 2,
        radius: 4,
        symbol: "circle",
        states: {
          hover: {
            enabled: true,
            fillColor: normalizedCostWidgetNormalizedBorderColor,
            radius: 4,
          },
        },
      },
    },
  ];

  return {
    categories,
    series: costData,
  };
};

export const normalizedCostWidgetActualCostColor = "#72BEF4";
const normalizedCostWidgetNormalizedColor = "#4DB6AC66";
export const normalizedCostWidgetNormalizedLineColor = "#5BB7AF";
const normalizedCostWidgetNormalizedBorderColor = "#4DB6AC";
